document.addEventListener("DOMContentLoaded", function () {

  const buttons = document.querySelectorAll("#artist-alpha-filter button");
  const artists = document.querySelectorAll("[data-artist-letter]");
  const header = document.querySelector(".shopify-section-header");

  const HEADER_OFFSET = header ? header.offsetHeight : 160;

  function updateButtonStates() {
    buttons.forEach(button => {
      const letter = button.getAttribute("data-letter");
      if (letter === "all") return;

      const hasArtist = Array.from(artists).some(artist => {
        return artist.getAttribute("data-artist-letter")?.toUpperCase() === letter;
      });

      button.disabled = !hasArtist;

      if (hasArtist) {
        button.style.background = "";
        button.style.color = "";
        button.style.cursor = "pointer";
        button.style.borderColor = "#000";
      } else {
        button.style.background = "#E3E3E3";
        button.style.color = "#666";
        button.style.cursor = "not-allowed";
      }
    });
  }

  updateButtonStates();

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      if (button.disabled) return;

      buttons.forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");

      const letter = button.getAttribute("data-letter");

      let firstVisibleArtist = null;

      artists.forEach(artist => {
        const artistLetter = artist.getAttribute("data-artist-letter")?.toUpperCase();
        const shouldShow = letter === "all" || artistLetter === letter;

        artist.style.display = shouldShow ? "block" : "none";

        if (shouldShow && !firstVisibleArtist) {
          firstVisibleArtist = artist;
        }
      });

      if (firstVisibleArtist) {
        const y =
          firstVisibleArtist.getBoundingClientRect().top +
          window.pageYOffset -
          HEADER_OFFSET -
          20; // small spacing

        window.scrollTo({
          top: y,
          behavior: "smooth"
        });
      }
    });
  });

});


//================ GOTO TOP BUTTON

document.addEventListener("DOMContentLoaded", function() {
  const goTopBtn = document.getElementById("go-to-top");
  if (!goTopBtn) return;

  window.addEventListener("scroll", () => {
    goTopBtn.style.display = window.scrollY > 200 ? "block" : "none";
  });

  goTopBtn.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});
